module.exports = __webpack_public_path__ + "static/media/bodasnet.4c06ec36.png";